import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { socialButtonsApi } from '../../services/api';
import type { SocialButton } from '../../types';
import { getUploadUrl } from '../../config/api';

const SocialButtons: React.FC = () => {
    const { i18n } = useTranslation();
    const [socialButtons, setSocialButtons] = useState<SocialButton[]>([]);

    useEffect(() => {
        const fetchSocialButtons = async () => {
            try {
                const { data } = await socialButtonsApi.getAll(i18n.language);
                if (data?.data) {
                    setSocialButtons(data.data);
                }
            } catch (err) {
                console.error('Error fetching social buttons:', err);
            }
        };

        fetchSocialButtons();
    }, [i18n.language]);

    if (socialButtons.length === 0) {
        return null;
    }
    return (
        <Box sx={{ display: 'flex' }}>
            {socialButtons.map((button) => {
                const iconUrl = button.icon ? getUploadUrl(button.icon.url) : null;
                return (
                    <Box
                        key={button.id}
                        component="a"
                        href={button.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-3px)',
                            },
                        }}
                    >
                        {iconUrl && (
                            <Box
                                component="img"
                                src={iconUrl}
                                alt={button.name}
                                sx={{
                                    width: 30,
                                    height: 30,
                                    objectFit: 'contain',
                                    filter: 'invert(1)',
                                }}
                            />
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default SocialButtons;
